import Link from 'next/link';
import type { ComponentProps, ReactNode } from 'react';

import styles from './hamburger-menu-item.module.scss';

type LinkProps = ComponentProps<typeof Link> & {
  isCurrentPage: boolean;
  icon?: ReactNode;
};

export const HamburgerMenuLinkItem = ({
  isCurrentPage,
  className,
  style,
  icon,
  children,
  ...rest
}: LinkProps) => {
  return (
    <li
      className={[styles.item, className].filter(Boolean).join(' ')}
      data-is-current-page={isCurrentPage}
      style={style}
    >
      <Link
        aria-current={isCurrentPage ? 'page' : undefined}
        className={styles.link}
        data-is-current-page={isCurrentPage}
        data-with-icon={!!icon}
        {...rest}
      >
        {children}
        {icon}
      </Link>
    </li>
  );
};

type ExternalLinkProps = ComponentProps<'a'> & {
  icon?: ReactNode;
};

export const HamburgerMenuExternalLinkItem = ({
  className,
  style,
  icon,
  children,
  ...rest
}: ExternalLinkProps) => {
  return (
    <li
      className={[styles.item, className].filter(Boolean).join(' ')}
      style={style}
    >
      <a className={styles.link} data-with-icon={!!icon} {...rest}>
        {children}
        {icon}
      </a>
    </li>
  );
};

type ButtonProps = ComponentProps<'button'>;

export const HamburgerMenuButtonItem = ({
  className,
  style,
  children,
  ...rest
}: ButtonProps) => {
  return (
    <li
      className={[styles.item, className].filter(Boolean).join(' ')}
      style={style}
    >
      <button className={styles.button} type="button" {...rest}>
        {children}
      </button>
    </li>
  );
};
